import { render, staticRenderFns } from "./RequestServiceReconsideration.vue?vue&type=template&id=8dd30842&scoped=true"
import script from "./RequestServiceReconsideration.vue?vue&type=script&lang=js"
export * from "./RequestServiceReconsideration.vue?vue&type=script&lang=js"
import style0 from "./RequestServiceReconsideration.vue?vue&type=style&index=0&id=8dd30842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd30842",
  null
  
)

export default component.exports